var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.808 5.02245L1.136 0.197604C0.864 -0.0658684 0.448 -0.0658684 0.192 0.197604C-0.0640005 0.461078 -0.0640004 0.905688 0.192 1.16916L4.4 5.5L0.192 9.83084C-0.064 10.1108 -0.064 10.5389 0.192 10.8024C0.448 11.0659 0.864 11.0659 1.136 10.8024L5.808 5.99401C6.064 5.71407 6.064 5.28593 5.808 5.02245Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.fb85f9ce35c1278fab5116331ec30de8.svg";
export { ForwardRef as ReactComponent };